import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { COMPARE_HEADER } from '../../constants/pricing/PriceDisplayOverrides';
import { usePricingInfoFromProductConfigurations, useProductConfigurationsFromProductLineAndLevel } from '../../hooks/upgradePageHooks';
import { useAppSelector } from '../../reducers';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import CurrentPlanButton from '../../upgrade-page/CurrentPlanButton';
import SuiteFeatureTableBadge from '../common/SuiteFeatureTableBadge';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { HighlightedPriceDisplay } from '../common/pricing/HighlightedPriceDisplay';
import FeatureTableCTA from './FeatureTableCTA';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TableHeaderCell = styled.th.withConfig({
  displayName: "HC0124CompareProFeatureTableHeaderCell__TableHeaderCell",
  componentId: "sc-1tiuzlg-0"
})(["text-align:center;font-weight:normal;position:relative;width:", ";padding:16px 0;"], ({
  columns
}) => columns < 3 ? `calc(50%/${columns})` : `calc(70%/${columns})`);
const badgeStyle = {
  position: 'static',
  top: '0'
};
const ctaStyles = {
  width: '212px',
  padding: '11px'
};
const HC0124CompareProFeatureTableHeaderCell = ({
  productLevel,
  columns,
  productLine,
  upgradePointProductLevel,
  ownedProductColumn,
  upgradePointApiName,
  purchaseMotions,
  handlePurchaseMotionButtonClick,
  feature
}) => {
  const isHighlightedCell = upgradePointProductLevel === productLevel;
  // Seats scenarios have only one column because we don't have an additional column for a product to compare.
  const isSeatsScenario = columns <= 1;
  const productConfigurations = useProductConfigurationsFromProductLineAndLevel({
    productLine,
    productLevel
  });
  const pricingInfo = usePricingInfoFromProductConfigurations(productConfigurations);
  const currencyCode = useAppSelector(activeCurrencySelector);
  const productConfigurationsLoaded = productConfigurations && productConfigurations.length;
  return /*#__PURE__*/_jsxs(TableHeaderCell, {
    columns: columns,
    scope: "col",
    children: [isHighlightedCell && /*#__PURE__*/_jsx(SuiteFeatureTableBadge, {
      use: 'new',
      translationKey: 'recommended',
      badgeStyle: badgeStyle
    }), /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        className: "flex-column m-top-1",
        message: `merchCards.businessObjectives.suite.${productLevel}.${productLine}.title`
      })
    }), ownedProductColumn && !isSeatsScenario ? /*#__PURE__*/_jsx("div", {
      className: "m-top-4",
      children: /*#__PURE__*/_jsx(CurrentPlanButton, {
        ctaStyles: Object.assign({}, ctaStyles, {
          visibility: 'visible'
        }),
        productLine: productLine
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HighlightedPriceDisplay, {
        pricingInfo: pricingInfo,
        skuId: pricingInfo.skuId,
        useLargePrice: false,
        priceDisplayOverride: COMPARE_HEADER,
        showDiscount: true,
        wrapperStyle: {
          textAlign: 'center'
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !productConfigurationsLoaded,
          heights: [38],
          widths: [210],
          className: "flex-column align-center",
          Content: FeatureTableCTA,
          contentProps: {
            currencyCode,
            productConfigurations,
            upgradePointApiName,
            purchaseMotions,
            ctaStyles,
            handlePurchaseMotionButtonClick,
            trackingSource: 'HC0124-Table-Header',
            feature
          }
        })
      })]
    })]
  }, productLevel);
};
export default HC0124CompareProFeatureTableHeaderCell;